import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Custom marker icon for mini map
const createMiniMarkerIcon = () => {
  return L.divIcon({
    className: 'mini-map-marker',
    html: `
      <div style="
        width: 24px;
        height: 24px;
        background: #ef4444;
        border-radius: 50% 50% 50% 0;
        transform: rotate(-45deg);
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 8px rgba(0,0,0,0.4);
        border: 2px solid white;
      ">
        <div style="
          width: 6px;
          height: 6px;
          background: white;
          border-radius: 50%;
          transform: rotate(45deg);
        "></div>
      </div>
    `,
    iconSize: [24, 24],
    iconAnchor: [12, 24],
  });
};

const MiniMapPreview = ({ latitude, longitude, zoom = 14, className = '' }) => {
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);

  // Default to Giresun center if no coordinates provided
  const lat = latitude || 40.9128;
  const lng = longitude || 38.3895;

  useEffect(() => {
    if (!mapContainerRef.current) return;

    // Initialize map if not already created
    if (!mapRef.current) {
      mapRef.current = L.map(mapContainerRef.current, {
        center: [lat, lng],
        zoom: zoom,
        zoomControl: false,
        attributionControl: false,
        dragging: false,
        touchZoom: false,
        scrollWheelZoom: false,
        doubleClickZoom: false,
        boxZoom: false,
        keyboard: false,
      });

      // Add tile layer - Using a clean, minimalist style
      L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
        maxZoom: 19,
      }).addTo(mapRef.current);

      // Add marker
      const marker = L.marker([lat, lng], { icon: createMiniMarkerIcon() });
      marker.addTo(mapRef.current);
    } else {
      // Update map view if coordinates change
      mapRef.current.setView([lat, lng], zoom);
    }

    return () => {
      // Cleanup on unmount
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, [lat, lng, zoom]);

  return (
    <div 
      ref={mapContainerRef} 
      className={`w-full h-full ${className}`}
      style={{ 
        borderRadius: 'inherit',
        overflow: 'hidden'
      }}
    />
  );
};

export default MiniMapPreview;
